export default __webpack_public_path__ + "static/media/DFP-Logo_white.5321f33c.png";